export enum BodyCoersionType {
  Html = 'html',
  Text = 'text',
}
